import React from 'react';
import './index.css';
import { Toaster } from 'react-hot-toast';

import reduceWaste from '../../../assets/images/ReduceWaste/reduce-waste.png';
import reduceWasteTablet from '../../../assets/images/ReduceWaste/reduce-waste-mobile.png';

export default () => {
  const desktopBanner = {
    backgroundImage: `url(${reduceWaste})`,
  };
  const tabletBanner = {
    backgroundImage: `url(${reduceWasteTablet})`,
  };

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <div className="page-content bg-white contactBanner">
        <div
          className="dz-bnr-inr dz-bnr-inr-md text-center overlay-black-middle backroungImage"
          style={window.innerWidth >= 988 ? desktopBanner : tabletBanner}
        >
          <div className="container">
            <div className="dz-bnr-inr-entry">
              <h1 className="text-white contactTitle">Program de prevenire si reducere a cantitatilor de deseuri</h1>
            </div>
          </div>
        </div>
      </div>

      <section className="content-inner contactForm">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="waste-reduction-content">
                <div className="company-header text-center mb-5">
                  <h2><strong>ROJEVAS 2000 SRL</strong></h2>
                  <p><strong>Sediul social: Targu Bujor, str. Mecanizatorilor, nr.5 C, Jud GALATI</strong></p>
                </div>

                <h1 className="text-center mb-4"><strong>PROGRAM DE PREVENIRE ȘI REDUCERE A CANTITĂȚILOR DE DEȘEURI</strong></h1>

                <div className="program-description mb-5">
                  <p>
                    Programul adoptă măsurile și metodele de prevenire și de minimizare a cantității de deșeuri rezultate din activitățile de <em><strong>Comerț cu amănuntul al carburanților pentru autovehicule în magazine specializate</strong></em> desfășurate de societate <strong>ROJEVAS 2000 SRL</strong> la cele 9 <span style={{ color: 'red' }}>puncte de lucru</span> în conformitate cu reglementările aplicabile și o evidență a gestiuni deșeurilor. Minimizarea deșeurilor se realizează prin:
                  </p>

                  <ul>
                    <li>prevenirea și/sau reducerea generării deșeurilor la sursă;</li>
                    <li>îmbunătățirea calității deșeurilor generate (ex: reducerea periculozității);</li>
                    <li>încurajarea refolosirii, reciclării și recuperării;</li>
                    <li>colectarea separată a deșeurilor.</li>
                  </ul>
                </div>

                <h4 className="mb-4">PROGRAMUL DE PREVENIRE ȘI REDUCERE A DEȘEURILOR</h4>

                <div className="program-implementation">
                  <p>
                    Societatea a implementat un plan de reducere a cantităților de deșeuri generate, prin asigurarea în principal a colectării selective a tuturor categoriilor de deșeuri generate din activitatea proprie și prin creșterea cantității de deșeuri reciclabile care se predau spre valorificare în raport cu deșeurile care se predau societăților autorizate spre eliminare.
                  </p>

                  <p>
                    Gestionarea deșeurilor se refera la depozitarea temporara, reutilizarea, colectarea, transportul, tratarea, reciclarea și eliminarea deșeurilor, principalul scop fiind economisirea materiei prime prin reutilizarea deșeurilor reciclabile, contribuind astfel la reducerea presiunii asupra resurselor naturale.
                  </p>
                  <p>
                    La baza activităţilor de gestionare a deşeurilor stau cateva principii enuntate in cadrul Strategiei Nationale de Gestionare a Deseurilor si a legislaţiei comunitare.
                  </p>
                </div>

                <div className="principles">
                  <ul>
                    <li><strong>principiul protecţiei resurselor primare</strong> – se referă la necesitatea de a minimiza şi eficientiza utilizarea resurselor primare, punând accentul pe utilizarea materiilor prime secundare;</li>
                    <li><strong>principiul prevenirii</strong> – pregătirea pentru reutilizare, reciclare, alte operațiuni de valorificare, și în ultimul rand eliminarea în condiții de siguranță pentru mediu (dezvoltarea de tehnologii curate, cu consum redus de resurse naturale);</li>
                    <li><strong>principiul substituției</strong> – necesitatea înlocuirii materiilor prime periculoase cu materii prime nepericuloase, conducând astfel la minimizarea cantităților de deșeuri periculoase;</li>
                    <li><strong>principiul subsidiarității</strong> – stabilește acordarea competentelor astfel încât deciziile în domeniul gestionarii deșeurilor să fie luate la cel mai scăzut nivel administrativ fata de sursa de generare;</li>
                    <li><strong>principiul proximității</strong> – stabilește că deșeurile trebuie tratate și eliminate cât mai aproape de sursa de generare;</li>
                    <li><strong>principiul măsurilor preliminare</strong> – aspectele principale de care trebuie ținut cont pentru orice activitate: stadiul curent al dezvoltării tehnologiilor, cerințele pentru protecția mediului, alegerea și aplicarea acelor masuri fezabile din punct de vedere economic.</li>
                  </ul>
                </div>

                <div className="objectives mb-5">
                  <p>
                    Primul obiectiv în domeniul gestionarii deșeurilor îl constituie reducerea la minimum a efectelor negative ale deșeurilor asupra sănătății populației și asupra mediului înconjurător. Prevenirea, reducerea consumului de resurse și aplicarea practica a "ierarhiei deşeurilor" clasifica diferitele opțiuni de gestionare a deșeurilor, de la cea mai buna, la cea mai puțin buna pentru mediu.
                    Daca evitarea producerii de deșeuri nu este întotdeauna posibila, atunci trebuie minimizata cantitatea de deșeuri generata prin reutilizare, reciclare și valorificare energetica. Etapa de eliminare a deșeurilor trebuie aplicata numai după ce au fost folosite la maxim toate celelalte mijloace, în mod responsabil, astfel încât să nu producă efecte negative asupra mediului.
                  </p>
                  <p>
                    Deșeurile se împart în două categorii mari: nepericuloase și periculoase fiind definite pe categorii în H.G nr. 856/2002 privind evidența gestiunii deșeurilor. Toate categoriile de deșeuri se colectează separat și se predau către societățile autorizate. La fiecare predare de deșeuri se va solicita și se va păstra bonul de confirmare sau formularul de încărcare - descarcare deșeuri în urma predării acestora către colectorii autorizați. Producătorii/detinătorii de deșeuri sunt obligați să predea deșeurile generate din activitatea sa operatorilor economici autorizați de către autoritatea publică competenta (Agențiile pentru Protecția Mediului) și să efectueze operații de colect
                  </p>
                </div>

                <h4 className="mb-4">MĂSURI PRIVIND MINIMIZAREA GENERĂRII CANTITĂȚILOR DE DEȘEURI</h4>

                <div className="waste-categories mb-5">
                  <p>
                    Din activitatea desfasurată se generează urmatoarele deșeuri care pot fi recuperate și valorificate:
                  </p>
                  <ul>
                    <li>deșeuri provenite din activitățile administrative sau de birou (tonere, imprimante, calculatoare, etc.)</li>
                    <li>deșeuri de ambalaje (plastic, hartie/ carton) provenite de la produsele alimentare si nealimentare comercializate</li>
                    <li>deseuri de namol cu continut de hidrocarburi</li>
                  </ul>

                  <p>
                    Cea mai mare pondere a deșeurilor generate o reprezintă deșeurile reciclabile, motiv pentru care, societatea va gestiona corect aceste tip de deseuri, prin reciclarea acestora prin societati autorizate in acest sens.
                  </p>
                </div>

                <div className="company-principles mb-5">
                  <p>
                    Principiile de baza ale societatii in domeniul gestionării sunt:
                  </p>
                  <ul>
                    <li>prevenirea și reducerea deșeurilor</li>
                    <li>instruirea angajaților în managementul deșeurilor si informarea clientilor cu privire la modul de colectare selectiva a ambalajelor de la diverse produse comercializate</li>
                    <li>monitorizarea fluxurilor de la achiziție produse până la valorificarea/ eliminare deșeurilor</li>
                    <li>valorificarea/eliminarea finală a deșeurilor catre societati autorizate in acest sens</li>
                  </ul>
                </div>

                <div className="conclusion mb-5">
                  <h4>Concluzii:</h4>
                  <p>
                    Societatea respectă cerințele legale prevăzute în Art. 22, alin.1 din OUG 92.2021 "persoana juridică ce exercită o activitate de natură comercială sau industrială, pentru care autoritatea competentă pentru protecția mediului a emis o autorizație de mediu/autorizație integrată de mediu, având în vedere rezultatele unui audit de deșeuri, este obligată să întocmească și să implementeze un program de prevenire și reducere a cantităților de deșeuri generate din activitatea proprie sau, după caz, de la orice produs fabricat, inclusiv măsuri care respectă un anumit design al produselor, și să adopte măsuri de reducere a periculozității deșeurilor" prin măsurile pe care le adoptă cu privire la monitorizarea și reducerea la minimum a efectelor negative ale deşeurilor asupra sănătăţii populaţiei şi a mediului înconjurător.
                  </p>
                </div>

                <div className="text-center mt-5">
                  <h6>ROJEVAS 2000 SRL</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};